import { BulmaType, ButtonProps, Modal } from '@easylife365/react';
import type { ConfirmationModalProps } from './types';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  isLoading,
  title,
  message,
  confirmText,
  confirmType = BulmaType.Primary,
  onConfirm,
  onCancel,
}) => {
  const ctaButtons: ButtonProps[] = [
    {
      bulmaType: confirmType,
      text: confirmText,
      icon: confirmType === BulmaType.Danger ? faTrash : undefined,
      loading: isLoading,
      disabled: isLoading,
      onClick: onConfirm,
    },
  ];

  return (
    <Modal ctaButtons={ctaButtons} title={title} show={show} onCancel={onCancel}>
      {message}
    </Modal>
  );
};

export default ConfirmationModal;
